import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
});

export const nowMealsApi = {
  getNowMeals: async (filters: any = {}) => {
    const {
      search,
      categoryId,
      isActive,
      isAvailable,
      isAddOn,
      page = 1,
      limit = 50,
      sortBy = "displayOrder",
      sortOrder = "asc",
    } = filters;
    let url = `${API_URL}/api/admin/now-meals?page=${page}&limit=${limit}&sortBy=${sortBy}&sortOrder=${sortOrder}`;

    if (search) url += `&search=${encodeURIComponent(search)}`;
    if (categoryId) url += `&categoryId=${encodeURIComponent(categoryId)}`;
    if (isActive !== undefined) url += `&isActive=${isActive}`;
    if (isAvailable !== undefined) url += `&isAvailable=${isAvailable}`;
    if (isAddOn !== undefined) url += `&isAddOn=${isAddOn}`;

    const response = await axios.get(url, { headers: getAuthHeaders() });
    return response.data;
  },

  getNowMealById: async (id: string) => {
    const response = await axios.get(`${API_URL}/api/admin/now-meals/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  createNowMeal: async (data: any) => {
    const response = await axios.post(`${API_URL}/api/admin/now-meals`, data, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  updateNowMeal: async (id: string, data: any) => {
    const response = await axios.put(`${API_URL}/api/admin/now-meals/${id}`, data, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  updateNowMealStock: async (id: string, currentStock: number | null) => {
    const response = await axios.patch(
      `${API_URL}/api/admin/now-meals/${id}/stock`,
      { currentStock },
      { headers: getAuthHeaders() }
    );
    return response.data;
  },

  deleteNowMeal: async (id: string) => {
    const response = await axios.delete(`${API_URL}/api/admin/now-meals/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },
};
